export default "__VITE_ASSET__9f9fbe0c__"